module.exports = __webpack_public_path__ + "img/hr-express-transport-belt.c43eccc3.png";